import archiefRaw from "../data/pm26-meldingen-archief.json";

const archief = archiefRaw as {
  datum: string;
  evenement: string;
  opdrachtgever?: string;
  cp_team: { naam: string; functie: string; afkorting: string }[];
  noot_afkortingen: string;
};

export function LogboekPM26() {
  return (
    <div className="space-y-4">
      <div
        className="rounded-2xl bg-ink-925 p-4"
        style={{ border: "1px solid rgba(255,255,255,0.06)" }}
      >
        <div className="flex items-center gap-2 mb-3">
          <span className="w-1.5 h-1.5 rounded-full bg-accent" />
          <span className="text-2xs tracking-eyebrow uppercase text-zinc-500">
            CPC Logboek · 18 jul 2026
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3 pb-3 mb-3 border-b border-white/[0.05]">
          <div>
            <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
              Event
            </div>
            <div className="text-zinc-100 text-sm font-medium mt-0.5 leading-tight">
              {archief.evenement}
            </div>
          </div>
          {archief.opdrachtgever && (
            <div>
              <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
                Opdrachtgever
              </div>
              <div className="text-zinc-100 text-sm font-medium mt-0.5">
                {archief.opdrachtgever}
              </div>
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 gap-3">
          {archief.cp_team.map((p) => (
            <div key={p.afkorting}>
              <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
                {p.functie}
              </div>
              <div className="text-zinc-100 text-sm font-medium mt-0.5">
                {p.naam}
              </div>
              <div className="text-2xs text-zinc-500 mt-0.5 tabular">
                {p.afkorting}
              </div>
            </div>
          ))}
        </div>
        <p className="text-2xs text-zinc-600 mt-3 leading-relaxed">
          {archief.noot_afkortingen}
        </p>
      </div>

      <div
        className="rounded-2xl px-4 py-3"
        style={{
          background: "rgba(255,180,80,0.05)",
          border: "1px solid rgba(255,180,80,0.18)",
        }}
      >
        <div className="text-2xs tracking-eyebrow uppercase text-zinc-400 mb-1.5">
          Sheet-koppeling
        </div>
        <p className="text-sm text-zinc-400 leading-relaxed">
          Het NEXXT-log voor Pal Mundo is nog niet gekoppeld (nieuwe sheet +
          function-deploy). Meldingen die je logt blijven veilig in de
          offline-wachtrij op dit toestel staan en worden automatisch
          doorgestuurd zodra de koppeling live is.
        </p>
      </div>
    </div>
  );
}
